import script from "./CardSurface.vue?vue&type=script&setup=true&lang=js"
export * from "./CardSurface.vue?vue&type=script&setup=true&lang=js"

import "./CardSurface.vue?vue&type=style&index=0&id=2b5d55c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5d55c1"]])

export default __exports__